import React, {useState} from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import moment from "moment";
import { adminSurucuArayanAprove } from "../../../features/admin3/admin3Slice";
import SmallSpinner from "../../shared/spinners/SmallSpinner";
import { setSelectedAdvertiser } from "../../../features/ilanlar/ilanlarSlice";
import { showModal } from "../../../features/modal/modalSlice";

const Container = styled.div`
  width: 100%;
  margin-block: 10px;
  .container {
    width: 100%;

    .content {
      width: 100%;
      padding: 15px 10px;
      border-radius: 10px;
      margin: 10px 0px 0px 0px !important;
      position: relative;
      background-color: ${({ theme }) => theme.secondaryBgColor};
      .row {
        width: 100%;
        display: grid;
        grid-template-columns: repeat(10, 1fr); 
        align-items: center;
        justify-content: center;
        gap: 15px;
        height: auto;
        .col {
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-md);
          text-align: center;
          gap: 10px;
          display: flex;
          flex-direction: column;
          p{
            border: 1px solid var(--color-main);
            padding: 5px;
            border-radius: 5px;
            color: var(--color-main);
            cursor: pointer;
          }
        }
      }
      .more{
        position: absolute;
        right: 10px;
        cursor: pointer;
        font-size: 20px;
      } 
      .detail{
        position: absolute;
        top: 10px;
        right: 40px;
        background-color: white;
        padding: 10px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 5px;
        cursor: pointer;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-md);
        color: var(--color-main);
        
      }
    }
  }
`;

const AdminSurucuArayanlarContainer = ({ data }) => {
  const { theme } = useSelector((state) => state.layout);
  const { isLoadingAdd } = useSelector((state) => state.admin3);
  const dispatch = useDispatch();
  
  const handleAprove = ({item, approve}) => {

    dispatch(adminSurucuArayanAprove({id: item?.id, isApproved:approve }))
  }

  return (
    <Container >
      <div onClick={() => {dispatch(setSelectedAdvertiser(data)); dispatch(showModal("adminDriverSeekerOptions"))}}  className="container">
        <div className="content">
          <div className="row">
            <div className="col">{moment(data?.createdAt).format('L')}</div>
            <div className="col">{data?.driverSeekerWorkCities?.$values?.map((item) => {return( <span>{item.city},{" "}</span> )})}</div>
            <div className="col">{data?.driverCount}</div>
            <div className="col">{data?.salary}</div>
            <div className="col">{data?.otherBenefits}</div>
            <div className="col">{data?.weekHoliday}</div>
            <div className="col">{data?.advertWithdrawalDate ? moment(data?.advertWithdrawalDate).format('L') : "-"}</div>
            {data?.isApproved === 0 && <div onClick={(e) => e.stopPropagation()} className="col">
              <p onClick={() => handleAprove({item: data, approve: 1})}>Onayla</p>
              <p onClick={() => handleAprove({item: data, approve: 2})}>Reddet</p>
            </div> }
            {data?.isApproved === 1 && <div className="col">Onaylandı</div> }
            {data?.isApproved === 2 && <div className="col">Reddedildi</div> }
            <div className="col">{data?.advertStatus}</div>
            <div className="col">{data?.isThereDriver === false ? "Hayır" : "Evet"}</div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default AdminSurucuArayanlarContainer;
